import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { usePostHog } from 'posthog-js/react';
import { selectAuth } from '../state/auth';
import { ROLES } from '../state/auth/types';
import { RootState } from '../state/store';

const COMPANY_GROUP_TYPE = 'company';

const roleNameByPid: Record<string, string> = Object.fromEntries(
  Object.values(ROLES).map((r) => [r.pid, r.name])
);

const PostHogIdentifier = () => {
  const posthog = usePostHog();
  const auth = useSelector(selectAuth);
  const companies = useSelector((state: RootState) => state.companies.data);
  const wasIdentified = useRef(false);

  const userId = auth?._id;
  const role = auth?.role;
  const firstName = auth?.firstName;
  const homeCompanyId = auth?.homeCompanyId ?? auth?.companyId;
  const activeCompanyId = auth?.companyId;
  const companyName = companies.find(
    (company) => company._id === activeCompanyId
  )?.companyName;
  const homeCompanyName = companies.find(
    (company) => company._id === homeCompanyId
  )?.companyName;

  useEffect(() => {
    if (!process.env.REACT_APP_POSTHOG_KEY) return;

    if (userId) {
      posthog.identify(userId, {
        name: firstName,
        firstName,
        role,
        roleName: role ? roleNameByPid[role] ?? role : undefined,
        homeCompanyId,
        companyName: homeCompanyName,
      });
      if (activeCompanyId) {
        posthog.group(
          COMPANY_GROUP_TYPE,
          activeCompanyId,
          companyName ? { name: companyName } : undefined
        );
      }
      wasIdentified.current = true;
    } else if (wasIdentified.current) {
      posthog.reset();
      wasIdentified.current = false;
    }
  }, [
    posthog,
    userId,
    role,
    firstName,
    homeCompanyId,
    activeCompanyId,
    companyName,
    homeCompanyName,
  ]);

  return null;
};

export default PostHogIdentifier;
